import SignUp from '../Pages/SignUp';
import SignIn from '../Pages/SignIn';
import VerifyEmail from '../Pages/VerifyEmail';
import EmailVerified from '../Pages/EmailVerified';
import SubmitConfirmationCode from '../Pages/SubmitConfirmationCode';

import TeacherReader from '../Pages/TeacherReader';
import TeacherDashboard from '../Pages/TeacherDashboard';
import TeacherCourseBuilder from '../Pages/TeacherCourseBuilder';
import TeacherLessonBuilder from '../Pages/TeacherLessonBuilder'

import EmployeeReader from '../Pages/EmployeeReader';
import EmployeeDashboard from '../Pages/EmployeeDashboard';
import OngoingEmployeeCourses from '../Pages/OngoingEmployeeCourses';
import EmployeeCourseOverview from '../Pages/EmployeeCourseOverview';

const signUp = {
  path: '/signUp',
  element: <SignUp />,
}
const signIn = {
  path: '/',
  element: <SignIn />,
}
const verifyEmail = {
  path: '/verifyEmail',
  element: <VerifyEmail />,
}
const submitConfirmationCode = {
  path: '/users/confirmation',
  element: <SubmitConfirmationCode />,
}

const emailVerified = {
  path: '/emailVerified',
  element: <EmailVerified />,
}
const teacherPreview = {
  path: '/lessons/:lessonId/preview',
  element: <TeacherReader />,
}

const teacherDashboard = {
  path: '/teacher/dashboard',
  element: <TeacherDashboard />,
}
const teacherCourseBuilder = {
  path: "teacher/courses/:courseId",
  element: <TeacherCourseBuilder />,
}

const teacherLessonBuilder = {
  path: "teacher/lessons/:lessonId/edit",
  element: <TeacherLessonBuilder />,
}

const employeeDashboard = {
  path: "/employee/dashboard",
  element: <EmployeeDashboard />,
}
const ongoingEmployeeCourses = {
  path: "/employee/dashboard/ongoing",
  element: <OngoingEmployeeCourses />,
}
const employeeReader = {
  path: 'courses/:courseId/lessons/:lessonId',
  element: <EmployeeReader />,
}
const employeeCourseOverview = {
  path: 'course/overview/:courseId',
  element: <EmployeeCourseOverview />,
}

export default [
  signUp,
  signIn,
  submitConfirmationCode,
  verifyEmail,
  emailVerified,

  
  employeeReader,
  employeeDashboard,
  employeeCourseOverview,
  ongoingEmployeeCourses,
  
  teacherPreview,
  teacherDashboard,
  teacherCourseBuilder,
  teacherLessonBuilder,
];
